import React from "react";
import { Navigate } from "react-router-dom";

interface RoleBasedComponentProps {
  managerComponent: React.ReactNode;
  adminComponent: React.ReactNode;
  userComponent: React.ReactNode;
  superadminComponent: React.ReactNode;
}

const RoleBasedComponent: React.FC<RoleBasedComponentProps> = ({
  managerComponent,
  adminComponent,
  userComponent,
  superadminComponent
}) => {
  const role = localStorage.getItem("role");

  switch (role) {
    case "manager":
      return <>{managerComponent}</>;
    case "admin":
      return <>{adminComponent}</>;
    case "super_admin":
      return <>{superadminComponent}</>;
    case "user":
      return <>{userComponent}</>;
    default:
      return <Navigate to="/login" replace />;
  }
};

export default RoleBasedComponent;